var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.appresize),attrs:{"id":"app"}},[_c('login-popup',{model:{value:(_vm.showLoginPopup),callback:function ($$v) {_vm.showLoginPopup=$$v},expression:"showLoginPopup"}}),_c('add-game-popup',{ref:"playingGamePopup",on:{"getGameSheQu":_vm.handlePlayingGameSelected,"closed":_vm.handlePlayingGamePopupClosed}}),_c('layout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }